<template>
  <v-dialog v-model="show" persistent max-width="760">
    <v-card
      width="760"
      style="padding: 24px; border-radius: 5px !important;">
      <div
        class="d-flex justify-space-between">
        <span
          class="primary--text font-weight-bold"
          style="font-weight: 18px;">
          Exportar Relatório
        </span>

        <v-icon @click="hideModal()">
          mdi-close
        </v-icon>
      </div>

      <div
        class="d-flex justify-center align-center flex-column"
        style="padding-top: 24px;">
        <v-icon
          color="success"
          size="24">
          mdi mdi-check-circle-outline
        </v-icon>

        <span
          class="font-weight-bold foreground--text"
          style="font-weight: 16px; padding-top: 8px;">
          Relatório solicitado com sucesso!
        </span>
      </div>

      <div
        style="padding-top: 35px;">
        <v-alert
          color="scroll-background mb-0"
          class="info--text">
          <v-row no-gutters>
            <v-col
              cols="12">
              <p class="font-weight-bold text-body-2">
                Trouxemos uma nova experiência para a emissão de relatórios de maioridade!
              </p>
              <p
                class="mb-0 pb-0 text-body-2">
                • Seus relatórios agora ficam na aba
                <span class="font-weight-bold">"Meus Relatórios"</span>;
              </p>
              <p
                class="mb-0 pb-0 text-body-2">
                • O histórico das suas emissões estará sempre disponível para consulta e download.
              </p>
            </v-col>
          </v-row>
        </v-alert>
      </div>

      <div
        class="d-flex justify-end gap-h-20"
        style="padding-top: 30px;">
        <v-btn
          outlined
          color="primary"
          :style="btnExport.style"
          @click="hideModal()">
          Cancelar
        </v-btn>

        <v-btn
          color="primary"
          :style="btnAction.style"
          @click="goToReportTab">
          Ir para Emissão de Relatórios
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import MajorityMixin from '@/shared/mixins/majority/majorityMixin';
import Textfield from './MajorityTextfield.vue';
import { mapMutations } from 'vuex';

export default {
  name: "ExportReportConfirmModal",

  components: {
    Textfield,
  },

  mixins: [
    MajorityMixin,
  ],

  props: {
    show: {
      type: Boolean,
      default: false,
    }
  },

  methods: {
    ...mapMutations({
      showExportConfirmModal: 'majority/showExportConfirmModal',
      setMajorityTab: 'majority/setMajorityTab',
    }),

    goToReportTab() {
      this.hideModal();
      this.setMajorityTab('reports');
    },

    hideModal() {
      this.showExportConfirmModal(false);
    }
  }
}
</script>